import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminLayout from '@/layouts/AdminLayout.vue'
import CardSecret from '@/views/CardSecret.vue'
import Customer from '@/views/Customer.vue'
import SmsTemplate from '@/views/SmsTemplate.vue'
import Goods from '@/views/Goods.vue'
import Login from '@/views/Login.vue'
import { isLoggedIn } from '@/utils/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { public: true }
  },
  {
    path: '/',
    component: AdminLayout,
    meta: { requiresAuth: true },
    redirect: '/card-secret',
    children: [
      {
        path: 'card-secret',
        name: 'CardSecret',
        component: CardSecret,
        meta: { title: '卡密资产总览', breadcrumb: '卡密信息管理' }
      },
      {
        path: 'customer',
        name: 'Customer',
        component: Customer,
        meta: { title: '客户信息管理', breadcrumb: '客户信息管理' }
      },
      {
        path: 'sms-template',
        name: 'SmsTemplate',
        component: SmsTemplate,
        meta: { title: '短信通知配置', breadcrumb: '短信模板管理' }
      },
      {
        path: 'goods',
        name: 'Goods',
        component: Goods,
        meta: { title: '商品信息管理', breadcrumb: '商品信息管理' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.public)
  const ok = isLoggedIn()

  if (!isPublic && !ok) {
    next({
      path: '/login',
      query: to.path !== '/login' ? { redirect: to.fullPath } : {}
    })
    return
  }

  if (to.path === '/login' && ok) {
    const r = to.query.redirect
    const target =
      typeof r === 'string' && r.startsWith('/') && !r.startsWith('//')
        ? r
        : '/card-secret'
    next(target)
    return
  }

  next()
})

export default router
